/* eslint-disable */
import { ChevronLeft } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Label } from '../../Components/ui/label'
import { Input } from '../../Components/ui/input'
import { Button } from '../../Components/ui/button'
import { toCurrency } from '../../utils/CurrencyUtil'
import { useModal } from '../../hooks/use-modal-store'
import env from '../../env/env'
import { post } from '../../http/restservice'
import { useRecoilState } from 'recoil'
import { formatIndianNumber, sanitizeName } from '../../utils/Util'
import { userDetailsState } from '../LoginState'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import PostHogTracker from '../../utils/PostHogTracker'
import OrderOtpVerification from '../FirstIdeas/OrderOtpVerification'

const MFRedeem = () => {
  const location = useLocation()
  const [fundDetails] = useState(location?.state?.fundDetails)
  const [fund] = useState(location?.state?.fund)

  const [userDetails] = useRecoilState(userDetailsState)
  const email = userDetails?.email

  const navigate = useNavigate()
  const { onOpen } = useModal()
  const [redemptionPercentage, setRedemptionPercentage] = useState(100)
  const [redemptionAmount, setRedemptionAmount] = useState(fund?.holding || 0)
  const [redemptionAmountDisplay, setRedemptionAmountDisplay] = useState(
    fund?.holding ? String(Math.floor(fund.holding)) : '0',
  )
  const [redemptionQty, setRedemptionQty] = useState(fund?.balance)
  const [fullSell, setFullSell] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [openOTPPopup, setOpenOTPPopup] = useState(false)
  const [error, setError] = useState('')

  const userData = JSON.parse(localStorage.getItem('userData'))
  const clientCode = userData?.uid.split('-')[0]
  const { showError } = useErrorPopup()

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })

    if (fundDetails) {
      PostHogTracker.redeemButtonClicked(fundDetails.schemeName, fund?.holding)
      PostHogTracker.pageViewed('Redeem Fund', {
        fund_name: fundDetails.schemeName,
        current_value: fund?.holding,
      })
    }
  }, [])

  const handleRedemptionAmountChange = (e) => {
    setError('')
    const value = e.target.value.replace(/[^0-9]/g, '')
    setRedemptionAmountDisplay(value)

    const numericValue = Number(value)
    if (!isNaN(numericValue) && numericValue >= 0) {
      setRedemptionAmount(numericValue)
      setFullSell(false)
      setRedemptionPercentage(0)

      if (numericValue > Number(fund?.holding)) {
        setError('Entered amount exceeds available balance')
      }

      if (numericValue > 0 && value.length > 2) {
        PostHogTracker.redemptionAmountEntered(numericValue, fundDetails?.schemeName)
        if (numericValue < fund?.holding) {
          PostHogTracker.partialRedemptionSelected(fundDetails?.schemeName, numericValue)
          PostHogTracker.redemptionTypeSelected('Partial')
        }
      }
    }
  }

  const handleRedemptionPercentage = (btn) => {
    setError('')
    setRedemptionPercentage(btn)

    const amount = Number(fund?.holding) || 0
    const calculatedAmount = (amount * btn) / 100
    const isFull = btn === 100

    setRedemptionAmount(calculatedAmount)
    setRedemptionAmountDisplay(String(Math.floor(calculatedAmount)))
    setRedemptionQty(isFull ? fund?.balance : ((fund?.balance / 100) * btn).toFixed(4))
    setFullSell(isFull)

    if (isFull) {
      PostHogTracker.fullRedemptionSelected(fundDetails?.schemeName, fund?.balance)
      PostHogTracker.redemptionTypeSelected('Full')
    } else {
      PostHogTracker.partialRedemptionSelected(fundDetails?.schemeName, calculatedAmount)
      PostHogTracker.redemptionTypeSelected('Partial')
    }
  }

  const redeemOrder = async () => {
    PostHogTracker.redemptionOrderPlaced(
      fundDetails?.schemeName,
      redemptionAmount,
      redemptionQty,
      fullSell ? 'Full' : 'Partial',
    )

    try {
      setIsLoading(true)

      const payload = {
        clientCode: clientCode?.toUpperCase(),
        schemeCode: fundDetails?.bseSchemeCode,
        folioNumber: fund?.folioNo,
        withdrawableAmount: redemptionAmount,
        isAllRedeem: fullSell ? 'Y' : 'N',
        phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
        isin: fundDetails?.isin,
      }

      const response = await post('mutualfundservice/api/bseStar/mfOrder/redeemOrder', payload)

      setIsLoading(false)

      if (!response.isError && response?.status === 'SUCCESS') {
        PostHogTracker.redemptionSuccess(fundDetails?.schemeName, redemptionAmount)
        onOpen('openPopup', {
          title: 'Redemption Order Processed',
          message:
            'Your redemption order is being processed and the amount will be credited to your bank account shortly.',
          severity: 'info',
        })
      }

      if (response.isError) {
        showError(
          'Redemption Failed',
          'There was an issue processing your redemption order. Please try again later or contact support for assistance.',
          () => {},
        )
      }
    } catch (error) {
      console.log('🚀 ~ redeemOrder ~ error:', error)
      setIsLoading(false)
    }
  }

  const generateOTP = async () => {
    setError('')

    if (Number(redemptionAmount) > Number(fund?.holding)) {
      return setError('Entered amount exceeds available balance')
    }

    setIsLoading(true)

    try {
      const response = await post(
        `${env.API_URL}mutualfundservice/api/mutualFund/sendTransactionalOtp`,
        {
          phoneNumber: userDetails?.phoneNumber,
          email: email?.includes('fabits') ? '' : email,
        },
      )

      if (response.isError) {
        PostHogTracker.buttonClicked('Order OTP Resend Failed', {
          action: 'Order OTP Resend Failed',
          page_name: 'Redeem Fund Page',
        })
        showError('OTP Error', 'Failed to generate OTP. Please try again later.', () => {})
        return
      }

      PostHogTracker.buttonClicked('Order OTP Resend Success', {
        action: 'Order OTP Resend Successful',
        page_name: 'Redeem Fund Page',
      })
      setOpenOTPPopup(true)
    } catch (error) {
      console.log('🚀 ~ generateOTP ~ error:', error)
      showError('OTP Error', 'Failed to generate OTP. Please try again later.', () => {})
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <div
        className='flex gap-x-1 items-center font-semibold cursor-pointer lg:py-2.5 p-4 lg:px-0'
        onClick={() => navigate(-1)}
      >
        <ChevronLeft className='h-5 w-5' />
        Redeem
      </div>

      <div className='max-w-[420px] mx-auto flex flex-col gap-y-6 px-4'>
        <div className='h-[200px] relative flex justify-center items-center shadow-sm border rounded-md'>
          <div className='flex flex-col justify-center items-center text-center w-full'>
            <img
              src={`${env.MF_LOGOS_URL}/${fundDetails?.amcCode}.png`}
              alt={fundDetails?.legalName}
              className='w-12 h-12 border rounded-lg'
            />
            <h3 className='font-semibold text-xl mt-2 px-4' style={{ textWrap: 'pretty' }}>
              {sanitizeName(fundDetails)}
            </h3>

            <div className='flex flex-col items-center justify-center mt-2'>
              <span className='text-sm text-black-400'>Available Balance</span>
              <span className='font-semibold text-primary-500 text-2xl'>
                ₹ {toCurrency(Math.floor(fund?.holding || 0))}
              </span>
            </div>
          </div>
        </div>

        <div className='flex flex-col space-y-6 p-4 rounded-md border'>
          <div className='flex flex-col items-start gap-1.5'>
            <Label htmlFor='amount' className='text-black-400 text-sm'>
              Withdrawal Amount
            </Label>
            <Input
              startAdornment='₹'
              type='amount'
              id='amount'
              placeholder='Amount'
              className='w-full'
              value={redemptionAmountDisplay}
              onChange={handleRedemptionAmountChange}
            />

            {error && <p className='text-center text-sm text-error-500'>{error}</p>}

            <div className='grid grid-cols-3 gap-x-2 mt-2 w-full'>
              {[10, 25, 50].map((btn, index) => (
                <Button
                  key={`${btn}-${index}`}
                  size='simple'
                  className={`p-2 rounded-md shadow-sm ${
                    btn === redemptionPercentage
                      ? 'bg-gray-50 border text-black hover:bg-gray-50'
                      : 'bg-gray-50 text-black-500 hover:bg-gray-50'
                  }`}
                  onClick={() => handleRedemptionPercentage(btn)}
                >
                  {`${btn}%`}
                </Button>
              ))}
            </div>

            <div className='grid grid-cols-3 gap-x-2 w-full'>
              {[75, 100].map((btn, index) => (
                <Button
                  key={`${btn}-${index}`}
                  size='simple'
                  className={`p-2 rounded-md shadow-sm ${btn === 100 ? 'col-span-2' : ''} ${
                    btn === redemptionPercentage
                      ? 'bg-gray-50 border text-black hover:bg-gray-50'
                      : 'bg-gray-50 text-black-500 hover:bg-gray-50'
                  }`}
                  onClick={() => handleRedemptionPercentage(btn)}
                >
                  {btn === 100 ? 'Full' : `${btn}%`}
                </Button>
              ))}
            </div>
          </div>
        </div>

        <div className='bg-warning-50 dark:bg-warning-950/20 rounded-lg p-4'>
          <div className='flex items-start gap-3'>
            <div className='space-y-1'>
              <h5 className='font-medium text-warning-900 dark:text-warning-100 flex items-center gap-x-1'>
                Important Notice
              </h5>
              <p className='text-sm text-warning-700 dark:text-warning-300'>
                Withdrawn funds will be transferred to your linked bank account within 1-5 business
                days.
              </p>
            </div>
          </div>
        </div>

        <Button
          className='rounded-md bg-primary-500 hover:bg-primary-400 disabled:bg-primary-200'
          loading={isLoading}
          onClick={generateOTP}
          disabled={
            isLoading ||
            Number(redemptionAmount) > Number(fund?.holding) ||
            Number(redemptionAmount) <= 0
          }
        >
          Continue Withdrawal
        </Button>
      </div>

      <OrderOtpVerification
        phoneNumber={userDetails?.phoneNumber}
        openOTPPopup={openOTPPopup}
        setOpenOTPPopup={setOpenOTPPopup}
        email={email}
        handleSipOrOT={redeemOrder}
      />
    </>
  )
}

export default MFRedeem
